import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

const Strings = require('../../../../app/shared/Strings');
const ChannelStore = require('../../stores/channel_store_reflux');
const ProjectStore = require('../../stores/ProjectStore');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const FeatureUtil = require('../../../../app/shared/FeatureUtil');
import ProjectDetails from '../project/ProjectDetails';
import ProjectAssignmentsOverview from './ProjectAssignmentsOverview';
import ProjectOverviewRangeChart from './ProjectOverviewRangeChart';
import ProjectShareRangeChart from './ProjectShareRangeChart';
import ProjectActivitiesOverview from './ProjectActivitiesOverview';
import ProjectActivitiesAnalyticsModal from '../modal/ProjectActivitiesAnalyticsModal';

// switch for disabling expensive project-level export of act over range totals
// use in PQA but not Live
const DISABLE_ACT_EXPORT = !GlobalConfig.CanUseLargeExports;

const propTypes = {
    className: PropTypes.string,
    channelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

const defaultProps = {
    className: ''
};

class ProjectAnalytics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleAnalyticsModalActionId: null,
            channelStoreState: ChannelStore.getStateChannel(props.channelId),
            projectStoreState: ProjectStore.getStateProject(props.projectId),
            showAnalyticsModal: false,
        };

        this.toggleAnalyticsModal = this.toggleAnalyticsModal.bind(this);

        this.unsubscribes = [
            ChannelStore.listen(this.onChannelStoreStateChange.bind(this)),
            ProjectStore.listen(this.onProjectStoreStateChange.bind(this)),
        ];
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.channelId !== prevProps.channelId
            || this.props.projectId !== prevProps.projectId
        ) {
            this.setState({
                channelStoreState: ChannelStore.getStateChannel(this.props.channelId),
                projectStoreState: ProjectStore.getStateProject(this.props.projectId)
            }); 
        }       
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onChannelStoreStateChange(state) {
        this.setState({
            channelStoreState: ChannelStore.getStateChannel(this.props.channelId)
        });
    }

    onProjectStoreStateChange(state) {
        this.setState({
            projectStoreState: ProjectStore.getStateProject(this.props.projectId)
        });
    }

    toggleAnalyticsModal(showBool) {
        this.setState({ showAnalyticsModal: showBool });
    }

    render() {
        if (
            !this.state.channelStoreState.initialized
            || !this.state.projectStoreState.initialized
        ) {
            return null;
        }

        const channel = this.state.channelStoreState.channel;
        const project = this.state.projectStoreState.project;
        if (
            !FeatureUtil.hasDetailedAnalytics(channel.channel_permissions)
            || !PermissionsUtil.viewDetailedProjectAnalytics(channel.user_permissions, project.user_permissions)
        ) {
            return null;
        }

        let canExportActAnalytics = false;
        if (
            FeatureUtil.hasDetailedAnalytics(channel.channel_permissions)
            && PermissionsUtil.viewDetailedChannelAnalytics(channel.user_permissions)
        ) {
            canExportActAnalytics = true;
        }

        return (
            <div className={this.props.className}>
                <div>
                    <h1 className="large-heading fl">
                        {!!this.state.projectStoreState.project ? this.state.projectStoreState.project.name : null}
                    </h1>
                    <Link
                        className="link-plain btn btn-primary fr"
                        to={`/analytics/${this.props.channelId}/${this.props.projectId}/activities`}
                        >
                        {Strings['en'].analytics.overview.FROM_PROJ_TO_ACT_LINK}
                    </Link>
                    {(canExportActAnalytics && !DISABLE_ACT_EXPORT) &&
                        <Button
                            className="fr margin-right-md"
                            disabled={!!this.state.toggleAnalyticsModalActionId}
                            onClick={this.toggleAnalyticsModal.bind(this, true)}
                            title={Strings['en'].analytics.overview.export.PROJ_ACT_EXPORT_HEADING}
                        >
                            {Strings['en'].analytics.overview.export.PROJ_ACT_EXPORT_HEADING}
                        </Button>
                    }
                </div>
                <div className="float-clear margin-bottom-lg" />
                <h2 className="large-heading margin-bottom-lg">
                    {Strings['en'].analytics.overview.project_details.SECTION_HEADING}
                </h2>
                <ProjectDetails {...this.props} className="margin-bottom-xl" />
                <h2 className="large-heading margin-bottom-lg">
                    {Strings['en'].analytics.overview.assignments_overview.SECTION_HEADING}
                </h2>
                <ProjectAssignmentsOverview {...this.props} />
                <h2 className="large-heading margin-bottom-lg">
                    {Strings['en'].analytics.overview.assignment_stats.SECTION_HEADING}
                </h2>
                <ProjectOverviewRangeChart {...this.props} />
                <h2 className="large-heading margin-bottom-lg">
                    {Strings['en'].analytics.overview.share_stats.SECTION_HEADING}
                </h2>
                <ProjectShareRangeChart
                    channelId={this.state.channelStoreState.channel.id}
                    projectId={this.state.projectStoreState.project.id}
                />
                <h2 className="large-heading margin-bottom-lg">
                    {Strings['en'].analytics.overview.activity_stats.SECTION_HEADING}
                </h2>
                <ProjectActivitiesOverview {...this.props} />

                {(this.state.showAnalyticsModal) && 
                    <ProjectActivitiesAnalyticsModal
                        channelId={this.state.channelStoreState.channel.id}
                        projectId={this.state.projectStoreState.project.id}
                        project={this.state.projectStoreState.project}
                        channel={this.state.channelStoreState.channel}
                        onClose={this.toggleAnalyticsModal.bind(this, false)}
                    />
                }
            </div>
        );
    }
}

ProjectAnalytics.propTypes = propTypes;
ProjectAnalytics.defaultProps = defaultProps;

export default ProjectAnalytics;